import { ReactElement } from 'react'

import { Badge, BadgeProps } from 'antd'
import classNames from 'classnames'

import * as styles from './styles.scss'

export const NavBadge = ({ className, ...props }: BadgeProps): ReactElement => (
    <Badge className={classNames(styles.navBadge, className)} {...props} />
)
